import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { CustomEase } from "gsap/CustomEase";
import { Draggable } from "gsap/Draggable";
import * as Tone from 'tone';
// const { Howl, Howler } = require('howler');



// Svg
// https://parceljs.org/languages/svg/#inlining-as-a-string
import playSvg from 'bundle-text:../../svg/play.svg';
import eyeSvg from 'bundle-text:../../svg/eyeFrame.svg';
// import eyeSvgTwo from 'bundle-text:../../svg/eyeFrame__elements.svg';
import handSvg from 'bundle-text:../../svg/hand_c.svg';
// CSS
import '../../styles/components/hand.scss';

//Audio 
// const soundURL = require("url:../../audio/terminator__01.mp3");
// const sound = new Howl({
//     src: soundURL,
//     volume: 0.5,
//     autoplay: false,
//     loop: true,
//     preload: true,
//     html5: false,
//     // onend: function() {
//     //     sound.play();
//     // }
// });
// let context;
// window.onload = function () {
//     context = new AudioContext();
// }



// Ready
document.addEventListener('DOMContentLoaded', function () {




    if (!hasTouch()) document.body.className += ' hasHover'
    function watchForHover() {
        // lastTouchTime is used for ignoring emulated mousemove events
        let lastTouchTime = 0

        function enableHover() {
            if (new Date() - lastTouchTime < 500) return
            document.body.classList.add('hasHover')
        }

        function disableHover() {
            document.body.classList.remove('hasHover')
        }

        function updateLastTouchTime() {
            lastTouchTime = new Date()
        }

        document.addEventListener('touchstart', updateLastTouchTime, true)
        document.addEventListener('touchstart', disableHover, true)
        document.addEventListener('mousemove', enableHover, true)

        enableHover()
    }

    watchForHover();


    function hasTouch() {
        return 'ontouchstart' in document.documentElement
            || navigator.maxTouchPoints > 0
            || navigator.msMaxTouchPoints > 0;
    }

    if (hasTouch()) { // remove all the :hover stylesheets
        try { // prevent exception on browsers not supporting DOM styleSheets properly
            for (var si in document.styleSheets) {
                var styleSheet = document.styleSheets[si];
                if (!styleSheet.rules) continue;

                for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                    if (!styleSheet.rules[ri].selectorText) continue;

                    if (styleSheet.rules[ri].selectorText.match(':hover')) {
                        styleSheet.deleteRule(ri);
                    }
                }
            }
        } catch (ex) { }
    }


    gsap.registerPlugin(CustomEase, MorphSVGPlugin, Draggable);


    // Inject Eye Svg
    const eyeSpans = document.querySelectorAll('#hm__video span:nth-of-type(1)');
    eyeSpans.forEach(function (eyeSpan) {
        eyeSpan.innerHTML = eyeSvg;
    });

    const eyeSpansTwo = document.querySelectorAll('#hm__video__top span:nth-of-type(1)');
    eyeSpansTwo.forEach(function (eyeSpanTwo) {
        eyeSpanTwo.innerHTML = eyeSvg;
    });

    // const eyeSpansTwo = document.querySelectorAll('#hm__video span:nth-of-type(2)');
    // eyeSpansTwo.forEach(function (eyeSpanTwo) {
    //     eyeSpanTwo.innerHTML = eyeSvgTwo;
    // });

    // Inject Play Svg
    const playSpans = document.querySelectorAll('#playSpans span');
    playSpans.forEach(function (handSpan) {
        handSpan.innerHTML = playSvg;
    });



    // Hand


    // Inject Hand Svg
    const handSpans = document.querySelectorAll('#hand span');
    handSpans.forEach(function (handSpan) {
        handSpan.innerHTML = handSvg;
    });


    // Animate
    gsap.set(".circlePalm", {
        transformOrigin: "center center",
        scale: 1.14
    });
    gsap.set(".squarePalm", {
        transformOrigin: "center center",
        scale: 1.14,
        autoAlpha: 0,
    });

    gsap.set("#theHand", {
        transformOrigin: "center center",
        y: 10,
        autoAlpha: 1,
    });

    gsap.to("#theHand", {
        duration: 0.25,
        delay: 0.5,
        y: "-=15",
    });

    theHand.addEventListener('mouseenter', function () {
        gsap.to(".squarePalm", {
            duration: 0.2,
            scale: 3,
            ease:
                CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
        });

        gsap.to("#theHand", {
            duration: 0.5,
            y: "-=5",
            ease:
                CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
        });
    });

    // Trigger Animation
    theHand.addEventListener('mouseleave', function () {
        gsap.to("#FingersPalm", {
            duration: 0.1,
        });
        gsap.to(theHand, {
            duration: 0.3,
            y: "+=5",
            ease:
                CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
        });
    });
    //

    const soundURL = require("url:../../audio/P_3_01.m4a");
    const soundURLTwo = require("url:../../audio/P_2_01.m4a");
    // Create a gain node for controlling the attack
    const attackGain = new Tone.Gain(0).toDestination(); // Initial gain is set to 0 to allow for the attack

    // Create the player
    const player = new Tone.Player({
        url: soundURL,
        loop: true,
        // loopStart: 0,
        // loopEnd: 1.5,
    }).connect(attackGain);

    // Create a delay effect
    const delay = new Tone.FeedbackDelay({
        delayTime: 0.875, // Adjust delay time as needed
        feedback: 0.5, // Adjust feedback level as needed
        wet: 0.75, // Adjust wetness of delay effect

    }).toDestination();

    player.volume.value = -1;

    // Connect the player to the delay effect
    attackGain.connect(delay);

    // Set the gain to 1 over the attack time (in seconds)
    attackGain.gain.setTargetAtTime(1, Tone.now(), 0.2); // Adjust attack time as needed

    // Gong
    function playGongSound() {
        const gongSynth = new Tone.Synth({
            oscillator: {
                type: 'triangle'
            },
            envelope: {
                attack: 0.675,
                decay: 4,
                sustain: 0.5,
                release: 4
            }
        }).toDestination();
        gongSynth.volume.value = -17;

        // Trigger the gong sound on click event
        // document.addEventListener('click', function () {
        gongSynth.triggerAttackRelease("F#2", "11n");
        // });
    }

    var hitIt = document.getElementById("hm__video");


    // hitIt.onclick = function (e) {
    //     playGongSound();
    // };

    // Set up a looping animation for pre-click effect
    const preClickAnimation = gsap.to(".circlePalm", {
        scale: "+=2.5",
        transformOrigin: "center",
        delay: 2,
        duration: 1.25,
        ease: "power4.in",
        repeat: -1, // Repeat indefinitely until clicked
        yoyo: true  // Creates a pulsing effect
    });

    // Click on Play/Pause button
    var playButtons = document.querySelectorAll('.playThisHand');
    playButtons.forEach(function (playButton) {
        if (playButton instanceof HTMLButtonElement) {
            playButton.onclick = function (event) {
                // Stop the pre-click animation on first click
                preClickAnimation.kill();
                event.stopPropagation();
                playButton.classList.toggle("active");
                if (video.paused) {
                    player.start();
                    // video.play();
                    setTimeout(() => {
                        video.play();
                        videoTop.play();
                    }, 200);
                    // animation.play();
                    // gsap.to("svg#range__svg", { autoAlpha: 1, scaleY: 1, duration: 0.075 });
                    // tl.reversed() ? tl.play() : tl.reverse();
                    visionEyetl.reversed() ? visionEyetl.play() : visionEyetl.reverse();
                    // visionEyePlayHeadtl.restart();

                    gsap.to(".squarePalm", {
                        duration: 0.125,
                        scale: 2.5,
                        autoAlpha: 1,
                        ease:
                            CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
                    });
                    gsap.to(".circlePalm", {
                        duration: 0.25,
                        scale: 0,
                        ease:
                            CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
                    });
                } else {
                    player.stop();
                    video.pause();
                    videoTop.pause();
                    // gsap.to("svg#range__svg", { autoAlpha: 0, duration: 0.25 });
                    visionEyetl.reversed() ? visionEyetl.play() : visionEyetl.reverse();
                    // animation.restart();
                    // tl.reversed() ? tl.play() : tl.reverse();
                    // visionEyePlayHeadStoptl.restart();
                    gsap.to(".squarePalm", {
                        duration: 0.125,
                        autoAlpha: 0,
                        scale: 3,
                        ease:
                            CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
                    });
                    gsap.to(".circlePalm", {
                        duration: 0.25,
                        scale: 5,
                        ease:
                            CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
                    });
                    //
                    // animation.reversed() ? animation.play() : animation.reverse();

                };


                // console.log('Sound Duration:' + sound._duration);
            };
        }
    });


    /// Video BGs
    const videoContainer = document.getElementById('hm__video');
    let video = document.createElement('video');
    video.setAttribute('loop', true);
    video.muted = "muted";
    video.pause();
    videoContainer.appendChild(video);
    video.src = new URL('../../video/MAH03652_1_1_1_1_2.mp4', import.meta.url);
    video.setAttribute('poster', new URL('../../video/MAH03652_1_1_1_1_2.jpg', import.meta.url));
    video.setAttribute('playsinline', true);
    if (video.hasAttribute("controls")) {
        video.removeAttribute("controls")
    };
    video.addEventListener("contextmenu", function (e) { e.preventDefault(); e.stopPropagation(); }, false);


    /// Video Top
    const videoTopContainer = document.getElementById('hm__video__top');
    let videoTop = document.createElement('video');
    videoTop.setAttribute('loop', true);
    videoTop.pause();
    videoTop.muted = "muted";
    videoTopContainer.appendChild(videoTop);
    videoTop.src = new URL('../../video/MAH03652_1_1_1_1_2.mp4', import.meta.url);
    videoTop.setAttribute('poster', new URL('../../video/MAH03652_1_1_1_1_2.jpg', import.meta.url));
    videoTop.setAttribute('playsinline', true);
    if (videoTop.hasAttribute("controls")) {
        videoTop.removeAttribute("controls")
    };
    videoTop.addEventListener("contextmenu", function (e) { e.preventDefault(); e.stopPropagation(); }, false);


    const visionEyeLoadIntl = gsap.timeline({ paused: false });

    const visionEyePlayHeadtl = gsap.timeline({ paused: true });
    const visionEyePlayHeadStoptl = gsap.timeline({ paused: true });

    gsap.set("#eyeOpen", { scaleY: 0, autoAlpha: 0 });
    gsap.set(".pup__head, .pup__tape", { autoAlpha: 0, scale: 0.9, transformOrigin: "center" });
    gsap.set("#hm__video, #hm__video__top", { scale: 1 });
    // gsap.set(".control__playPause", { scale: 0.8, autoAlpha: 0 });
    // gsap.to(".control__playPause", { scale: 1, autoAlpha: 1, duration: 0.0875, delay: 3 });
    // gsap.to(".tapes span", { x: 0, autoAlpha: 1, duration: 0.124, delay: 1, stagger: 0.1, });


    visionEyeLoadIntl
        .from("#eyeOpen", {
            scaleY: 0,
        })
        .to("#eyeOpen", {
            delay: 0.125,
            autoAlpha: 1,
            scaleY: 0.8,
            scaleX: 0.95,
            duration: 0.375,
            ease: CustomEase.create("custom", "M0,0 C0.135,0 0.238,0.029 0.315,0.177 0.478,0.494 0.352,1 1,1 "),
        })
        // .to(".pup", {
        //     morphSVG: {
        //         shape: ".pup",
        //     },
        //     scaleX: 1.1,
        //     scaleY: 1.2,
        //     duration: 0.24,

        // }, "-=0.0675")
        // .to(".pup", {
        //     morphSVG: {
        //         shape: ".pup__two",
        //     },
        //     ease: CustomEase.create("custom", "M0,0 C0.135,0 0.238,0.029 0.315,0.177 0.478,0.494 0.352,1 1,1 "),
        //     scaleX: 1,
        //     scaleY: 1,
        //     duration: 0.25,
        // })
        .to("#eyeOpen", {
            scaleY: 0.7,
            duration: 1,
            ease: CustomEase.create("custom", "M0,0 C0.135,0 0.238,0.029 0.315,0.177 0.478,0.494 0.352,1 1,1 "),
        })
        .to("#eyeOpen", {
            scaleY: 0.825,
            duration: 1,
            ease: CustomEase.create("custom", "M0,0 C0.135,0 0.238,0.029 0.315,0.177 0.478,0.494 0.352,1 1,1 "),
        })

        ;


    const visionEyetl = gsap.timeline({ paused: true, reversed: true });
    gsap.set(".pup, .pup__two", { transformOrigin: "center", autoAlpha: 0 });


    visionEyetl.timeScale();

    visionEyetl

        .to("#eyeOpen", {
            scaleY: 0,
            repeat: 1,
            yoyo: true,
            duration: 0.25,
            ease: CustomEase.create("custom", "M0,0 C0.135,0 0.238,0.029 0.315,0.177 0.478,0.494 0.352,1 1,1 "),
        })
        // 
        // .to(".pup", {
        //     autoAlpha: 0,
        //     scale: 0.9,
        //     duration: 0.25,
        // }, "-=0.125")
        // .to(".pup__tape", {
        //     scale: 1,
        //     autoAlpha: 1,
        //     duration: 0.25,
        // }, "+=0.125")
        // .to(".pup__head", {
        //     scale: 1,
        //     autoAlpha: 1,
        //     duration: 0.25,
        // }, "+=0.125")
        // .add("play")
        // .to(".pup__tape", {
        //     autoAlpha: 0,
        //     duration: 0.5,
        // })
        // .to(".pup__head", {
        //     rotate: 360,
        //     repeat: -1,
        //     duration: 4,
        //     ease: 'none',
        // }, "play")
        // .to(".pup__tape", {
        //     rotate: 360,
        //     repeat: -1,
        //     duration: 4,
        //     ease: 'none',
        // }, "play")

        ;


    visionEyePlayHeadtl
        .to(".pup", {
            autoAlpha: 0,
            scale: 0.9,
            duration: 0.125,
        })
        .to(".pup__head", {
            scale: 0.75,
            autoAlpha: 1,
            duration: 0.25,
        }, "+=0.125")
        .to(".pup__head", {
            rotate: 360,
            repeat: -1,
            duration: 4,
            ease: 'none',
        }, "-=0.375");

    visionEyePlayHeadStoptl
        .to(".pup__head", {
            scale: 0,
            autoAlpha: 0,
            duration: 0.125,
        })
        .to(".pup", {
            autoAlpha: 1,
            scale: 1,
            duration: 0.25,
        }, "+=0.124");






    // Function to initialize the synthesized gong sound
    function initGongSoundTwo() {
        const gongSynthTwo = new Tone.Synth({
            oscillator: {
                type: 'triangle'
            },
            envelope: {
                attack: 2,
                decay: 2,
                sustain: 0.5,
                release: 4
            }
        }).toDestination();

        // Lower the volume of the synth
        gongSynthTwo.volume.value = -17; // Adjust the volume level as needed (-12 dB here)

        return gongSynthTwo;
    }

    // Initialize the synthesized gong sound
    const gongSynthTwo = initGongSoundTwo();

    // Variable to keep track of whether the gong sound is currently playing
    let isGongPlaying = false;



    let itemPeel = document.getElementsByClassName("item__peel")[0];
    let itemPeelLeft = document.getElementsByClassName("item__peel__left")[0];

    gsap.set(".__player.__hand #hand span svg#theHand", {
        transformOrigin: "center",
    });

    // Create a second player and gain node for the drag sound
    const attackGainTwo = new Tone.Gain(0).toDestination();
    const playerTwo = new Tone.Player({
        url: soundURLTwo,
        loop: true,
    }).connect(attackGainTwo);

    // Create a second delay effect for the second player
    const delayTwo = new Tone.FeedbackDelay({
        delayTime: 0.875,
        feedback: 0.75,
        wet: 1,
    }).toDestination();

    playerTwo.volume.value = -5;
    attackGainTwo.connect(delayTwo);

    Draggable.create(itemPeelLeft, {
        type: "x,y",
        edgeResistance: 1.5,
        throwProps: true,
        allowEventDefault: true,
        bounds: ".__player__one",

        onClick: function () {
            playGongSound();
            gsap.to("#eyeOpen", {
                scaleY: 0,
                repeat: 1,
                yoyo: true,
                duration: 0.25,
                ease: CustomEase.create("custom", "M0,0 C0.135,0 0.238,0.029 0.315,0.177 0.478,0.494 0.352,1 1,1 "),
            });
        },

        onDragStart: function () {
            playGongSound();
            // Start the second player
            playerTwo.start();
            // Fade in the second player
            attackGainTwo.gain.rampTo(1, 0.5);
            
            gsap.to("#eyeOpen", {
                scaleY: 0.2,
                duration: 1,
            });
            gsap.to("#hm__video", {
                opacity: 0,
                duration: 0.1
            });
        },

        onDrag: function () {
            itemPeelLeft.className = "item__peel__left active";
            gsap.to(".__player.__hand #hand span svg#theHand", {
                duration: 0.2,
                x: -1,
                y: -4,
                rotate: "-2deg",
                scale: 1.05,
                opacity: 0,
            });

            if (!isGongPlaying) {
                gongSynthTwo.triggerAttack("C#2");
                isGongPlaying = true;
            }

        },
        onDragEnd: function () {
            // Fade out the second player
            attackGainTwo.gain.rampTo(0, 0.5);
            // Stop the player after fade out
            setTimeout(() => playerTwo.stop(), 500);

            itemPeelLeft.className = "item__peel__left";

            gsap.to("#eyeOpen", {
                scaleY: 0.825,
                duration: 1,
                ease: CustomEase.create("custom", "M0,0 C0.135,0 0.238,0.029 0.315,0.177 0.478,0.494 0.352,1 1,1 "),
            })
            gsap.to("#hm__video", {
                opacity: 1,
                duration: 0.5
            });

            gsap.to(".__player.__hand #hand span svg#theHand", {
                duration: 0.2,
                rotate: "0deg",
                scale: 1,
                x: 0,
                y: 0,
                autoAlpha: 1,
                ease:
                    CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });

            gongSynthTwo.triggerRelease();
            isGongPlaying = false;
        },
    });

    const parentContainer = document.querySelector('.coordinates');




    Draggable.create(itemPeel, {
        type: "x,y",
        edgeResistance: 1.5,
        throwProps: true,
        allowEventDefault: true,
        bounds: ".__player",

        onClick: function () {
            playGongSound();
            gsap.to("#eyeOpen", {
                scaleY: 0,
                repeat: 1,
                yoyo: true,
                duration: 0.25,
                ease: CustomEase.create("custom", "M0,0 C0.135,0 0.238,0.029 0.315,0.177 0.478,0.494 0.352,1 1,1 "),
            });
        },

        onDragStart: function () {
            playGongSound();
            // Start the second player
            playerTwo.start();
            // Fade in the second player
            attackGainTwo.gain.rampTo(1, 0.5);

            gsap.to("#eyeOpen", {
                scaleY: 0.2,
                duration: 0.5,
            });

            gsap.to("#hm__video__top", {
                opacity: 0,
                duration: 0.1
            });
        },

        onDrag: function () {
            itemPeel.className = "item__peel active";
            gsap.to(".__player.__hand #hand span svg#theHand", {
                duration: 0.2,
                x: 1,
                y: -4,
                rotate: "3deg",
                scale: 1.06,
                opacity: 0,
            });

            if (!isGongPlaying) {
                gongSynthTwo.triggerAttack("G#1");
                isGongPlaying = true;
            }
        },

        onDragEnd: function () {
            // Fade out the second player
            attackGainTwo.gain.rampTo(0, 0.5);
            // Stop the player after fade out
            setTimeout(() => playerTwo.stop(), 500);

            itemPeel.className = "item__peel";

            gsap.to("#hm__video__top", {
                opacity: 1,
                duration: 0.5
            });
            gsap.to(".__player.__hand #hand span svg#theHand", {
                duration: 0.2,
                rotate: "0deg",
                scale: 1,
                x: 0,
                y: 0,
                autoAlpha: 1,
                ease:
                    CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });
            gsap.to("#eyeOpen", {
                scaleY: 0.825,
                duration: 1,
                ease: CustomEase.create("custom", "M0,0 C0.135,0 0.238,0.029 0.315,0.177 0.478,0.494 0.352,1 1,1 "),
            });
            gongSynthTwo.triggerRelease();
            isGongPlaying = false;
        },
    });

    gsap.set(".handLayer", { transformOrigin: "bottom center" });

    Draggable.create(hand, {
        type: "x,y",
        edgeResistance: 2.2,
        throwProps: true,
        allowEventDefault: true,
        bounds: "article",
        onDrag: function () {
            itemPeel.className = "item__peel active";

            gsap.to(".handLayer", {
                duration: 0.2,
                rotate: "-2deg",
                ease:
                    CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });
        },
        onDragEnd: function () {
            itemPeel.className = "item__peel";

            gsap.to(".handLayer", {
                duration: 0.2,
                rotate: 0,
                ease:
                    CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });

        },
    });


}, false);





